import { BaseAvatarCell } from "./BaseAvatarCell";
import type { Child } from "@/types/child";

interface ChildAvatarCellProps {
  child: Child;
  onClick: () => void;
}

/**
 * Avatar cell component for children table that handles avatarUrl field
 * Resolves image IDs to URLs using the image service when needed
 * Supports both UUID image IDs and direct URLs (http/https/data/blob/relative paths)
 */
export function ChildAvatarCell({ child, onClick }: ChildAvatarCellProps) {
  return <BaseAvatarCell entity={child} onClick={onClick} />;
}